<template>
  <layout>
  <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
  <div slot="content">
    
    <div class="pop-content-search">
      <el-form size="mini">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-row>
              <el-col :span="24">
                <el-form-item label="검색타입">
                  <el-col :span="16">
                    <el-select v-model="form.searchType" placeholder="검색타입선택">
                      <el-option
                        v-for="item in searchTypeOpt"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="18">
                <el-form-item label="검색어">
                  <el-col :span="14">
                    <el-input type="input" v-model="form.searchText"></el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" icon="el-icon-search" @click="selectDeptMember">
                        검색
                    </el-button>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="부서">
              <el-select v-model="form.deptCd1" placeholder="부서선택" @change="deptChange">
                <el-option
                  v-for="item in deptCd1Opt"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
              <el-select v-model="form.deptCd2" placeholder="부서선택" v-show="dept2Show">
                <el-option
                  v-for="item in deptCd2Opt"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
    </div>

    <!-- grid s. -->
    <div class="grid-wrap">
      <div class="talbe-contain" style="display: flex;border: 1px solid #a6acb1;border-radius: 3px;">
        <div class="table-area" style="margin-right: 50px; width: 20%;">
            <div class="table-b">
              <el-tree class="custom-tree" :data="trees" :props="defaultProps" @node-click="handleNodeClick" default-expand-all></el-tree>
            </div>
        </div>
        <div class="table-area" style="margin-right: 10px; width: 80%">
          <div class="table-b">
            <ag-grid-vue 
            style="width: 100%; height: 330px;"
            class="ag-theme-alpine"    
            row-selection="single"
            :column-defs="columnDefs"
            :grid-options="gridOptions"
            :row-data="rowData"
            :default-col-def="defaultColDef"
            @cell-clicked="onCellClicked"
            @grid-ready="onGridReady"/>
          </div>
        </div>
      </div>
    </div>
    <!-- grid e. -->
    <el-form size="mini" label-width="80px" style="margin: 10px 0 0 -10px;">
      <el-row>
        <el-col :span="8">
          <el-form-item label="부서명">
            <el-input v-model="subForm.deptNm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="직책">
            <el-input v-model="subForm.dutyId" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="이름">
            <el-input v-model="subForm.userNm" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="담당업무">
          <el-input type="textarea" v-model="subForm.description" readonly></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="전화번호">
            <el-row>
              <el-col :span="8">
                <el-select v-model="mobileGb">
                  <el-option value='m' label="핸드폰"></el-option>
                  <el-option value='h' label="전화번호"></el-option>
                  <el-option value='i' label="내선"></el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-input v-model="subForm.telNo" readonly></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="내선">
            <el-input v-model="subForm.telNo2" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="핸드폰">
            <el-input v-model="subForm.hpNo" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </div>
</layout>
</template>

<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

import mixin from './index';

function getTreeData(array){
  var map = {};
  for(var i = 0; i < array.length; i++){
      var obj = {"catId" : array[i]['catId'], "label" : array[i]['catNm'], "catKey" : array[i]['catKey'], "LVL" : array[i]['catLvl']};
      obj.children = [];
      map[obj.catId] = obj;
      var parent = array[i]['parentId'] || '-';

      if(!map[parent]){
          map[parent] = {
              children: []
          };
      }
      map[parent].children.push(obj);
  }

  return map['-'].children;
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  mixins: [mixin],
    props: {
        data: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
  components: {Layout, AgGridVue},
  data() {
      return {
          title: '담당자연결',
          form: {
            searchText: '', /** 검색어 */
            searchType: '', /** 검색타입 */
            deptCd1: '',
            deptCd2: ''
          },
          subForm:{
            deptNm: '',
            dutyId: '', // 직책
            userNm: '', // 이름
            description: '', // 담당업무
            telNo : '', // 전화번호
            telNo2: '', // 내선
            hpNo : ''
          },
          searchTypeOpt: [], /** 검색타입 */
          deptCdOpt: [],
          deptCd1Opt: [],
          deptCd2Opt: [],
          dept2Show: false, 
          deptCd: '1',
          mobileGb: 'h',
          // AG-GRID OPTION [START]
          rowData:[],
          gridOptions: {},
          columnDefs:[
            {
              headerName: '부서명', 
              field:'deptNm',
              width: 150, 
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '담당자', 
              field:'userNm',
              width: 150, 
              cellStyle:{textAlign:'center'},
              cellRenderer: (params) => {
                  return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
              }
            },
            {
              headerName: '담당업무', 
              field:'description', 
              width: 150,
              cellStyle:{textAlign:'left'}
            },                    
          ],
          defaultColDef: { 
              resizable: true, 
              filter:true, 
              sortable: true 
          },
          trees: [{
            label: '전체',
              children: [{
                label: '고객센터',
                children: 
                  [{
                    label: '총괄',
                  },
                  {
                    label: '운영팀',
                  },
                  {
                    label: '기술팀',
                  },
                  {
                    label: '고객센터',
                  },
                  {
                    label: '대우루컴즈',
                  }
                ]
              }]
          }],
          defaultProps: {
            children: 'children',
            label: 'label'
          }
      }
  },
  created() {
    this.form = this.data;
    this.$bus.$on('input', (val) => {
        console.log('-> input bus on ', val);
    });
  },
  mounted() {
      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');

      this.getCombo({flag: 'INIT'});
      
  },
  destroyed() {
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '7');
  },
  methods: {
      
      closeModal() {
          this.$parent.close();
      },
      handleNodeClick(param) {
          console.log('node click: ', param);
          
          if(param.LVL === 0){
            this.dept2Show = false
            
            if( typeof(this.form.deptCd1)=== 'string'){
              this.form.deptCd1 = ''
            }
            if( typeof(this.form.deptCd2)=== 'string'){
              this.form.deptCd2 = ''
            }
          }else if(param.LVL === 1){
            this.deptChange(param.catKey+'')
          } else {
            this.dept2Show = true
            if( this.form.deptCd2 == undefined || typeof(this.form.deptCd2)=== 'string'){
              this.form.deptCd2 = param.catKey+''
            }
          }

          this.selectDeptMember();

      },
      onGridReady(){
      
      },
      onCellClicked(params) {
          const field = params.colDef.field;
          console.log('onCellClicked start field: ', field, params)

          if(field === 'userNm') {
            console.log('onCellClicked start 2', params.data.deptNm, params.data.userNm)
            this.subForm.deptNm = params.data.deptNm
            this.subForm.dutyId = params.data.dutyId // 직책
            this.subForm.userNm = params.data.userNm // 이름
            this.subForm.description = params.data.description // 담당업무
            this.subForm.telNo = _phone(params.data.telNo) // 전화번호
            this.subForm.telNo2 = _phone(params.data.telNo2) // 내선
            this.subForm.hpNo = _phone(params.data.hpNo) // 휴대폰
            
            this.$emit('changeCharge', params.data);
          } else {
            console.log('onCellClicked start 3', params.data.deptNm)

          }
      },
      getCombo(param) {
        if(param.flag === 'INIT'){
            // UserSelectSearchType
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: '212'}})
            .then(response => {
                this.searchTypeOpt = response.data || [];
                this.searchTypeOpt.unshift({key:'', value:'선택'});
              
                this.selectDeptMember();
            });
          }

          
          this.$store.commit('loading')
          this.$http.post(("/api/asMng/call/selectDept"), {}
              ).then(response => {
              
                let treeObj = JSON.parse(JSON.stringify(response.data))
                treeObj.unshift({deptCd:'', deptId:'0',  deptLvl:0, deptNm:'전체', parentId:''})
                const vTreeData = treeObj.map((x,index)=>{
                  x.catId = 'ID' + x.deptId
                  x.catNm = x.deptNm
                  x.catLvl = x.deptLvl
                  x.catKey = x.deptId+''
                  x.parentId = index > 0 ? 'ID' + x.parentId : ''
               
                  return x
                })
                console.log('dept List: ' , response.data, vTreeData)

                this.trees = getTreeData(vTreeData)

              this.deptCd1Opt = response.data.filter(x=>x.deptLvl === 1).map(y=>{
                const vObj = {
                  label : y.deptNm,
                  value : y.deptId+'',
                  key : y.deptId+''
                }

                return vObj
              })
              let deptFirstKey = ''
              if(this.deptCd1Opt && this.deptCd1Opt.length >0 ){
                deptFirstKey = this.deptCd1Opt[0].key
                console.log('deptFirstKey type: ', typeof(deptFirstKey), deptFirstKey)
              }
              this.deptCd1Opt.unshift({label:'전체', value:'', key: ''})

              this.deptCd2Opt = response.data.filter(x=>x.deptLvl === 2).map(y=>{
                const vObj = {
                  label : y.deptNm,
                  value : y.deptId+'',
                  key : y.deptId+''
                }
                
                return vObj
              })
              this.deptCd2Opt.unshift({label:'전체', value:'', key: ''})

              this.form.deptCd1 = deptFirstKey
              this.deptChange(deptFirstKey)
              
          }).finally(() => {
              this.$store.commit('finish');
              
          });

      }, 
      deptChange(param){
        // console.log('dept change: ', param, typeof(param), typeof(this.form.deptCd2))
        this.dept2Show = true
        
        if( typeof(this.form.deptCd2)=== 'string'){
          this.form.deptCd2 = ''
        }

        if(param === ''){
          this.dept2Show = false
        } else {
          this.dept2Show = true
        }
      },
      selectDeptMember(){
        console.log('selectDeptMember start')
        let vDeptId = this.form.deptCd2
        if(!vDeptId || vDeptId === ''){
          vDeptId = this.form.deptCd1 || '0'
        }

        const vform = {
              companyId: this.$store.state.loginInfo.compCd,
              ctiYn: '',
              deptId: vDeptId,
              searchType: this.form.searchType || '',
              searchText: this.form.searchText || '',
              sortType: ' ',
              page: 1,
              totalpage: 9999,
              totalcount: 9999,
              curPage: 0,
              processTime : ''
            }
            console.log('selectDeptMember vform: ', vform)

        this.$http
          .post("/api/asMng/call/selectEmpList", vform)
            .then(response => {
              console.log('selectDeptMember response: ', response)
              this.rowData = response.data
            }).finally(() => {
        });

      }
  }

}
</script>

<style lang="scss" scoped>
.modal-card {
width: 970px;
}

.display-area {
:global(img) {
  width: 100%;
}
}
</style>